import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ReactElement, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { pushThankYouPageView, pushWppThankYouClick } from "../../../utils/gtm";
import womanCallCenter from "../../assets/woman-callcenter.webp";
import { FooterSuccess } from "../../components/footer/footer-success";
import { HeaderSuccess } from "../../components/header-success/header-success";

const LIME = "#5CDC1A";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Page = styled.div`
  align-items: center;
  background: #fff;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 60px 24px;
`;

const Title = styled.h1`
  align-items: center;
  color: #111;
  display: flex;
  font-size: 42px;
  font-weight: 700;
  gap: 14px;
  text-align: center;

  @media (max-width: 480px) {
    font-size: 28px;
    gap: 10px;
  }
`;

const CheckBadge = styled.span`
  align-items: center;
  background: ${LIME};
  border-radius: 50%;
  color: #fff;
  display: inline-flex;
  flex-shrink: 0;
  height: 50px;
  justify-content: center;
  width: 50px;

  @media (max-width: 480px) {
    height: 38px;
    width: 38px;
  }
`;

const Subtitle = styled.p`
  color: #999;
  font-size: 18px;
  font-style: italic;
  line-height: 1.7;
  margin-bottom: 20px;
  max-width: 440px;
  text-align: center;

  @media (max-width: 480px) {
    font-size: 16px;
  }
`;

const Hint = styled.p`
  color: #666;
  font-size: 14px;
  margin-bottom: 18px;
  text-align: center;
`;

const WhatsAppButton = styled.a`
  background: ${LIME};
  border-radius: 50px;
  color: #111;
  display: inline-block;
  font-size: 20px;
  font-weight: 700;
  padding: 18px 52px;
  text-align: center;
  text-decoration: none;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.88;
  }

  @media (max-width: 480px) {
    font-size: 16px;
    padding: 14px 32px;
    width: 100%;
  }
`;

export function CadastroSucesso(): ReactElement {
  const { state } = useLocation();
  const whatsapp = (state as { whatsapp?: string })?.whatsapp ?? "";
  const whatsappHref: string = `https://api.whatsapp.com/send/?phone=${whatsapp}&text=Ol%C3%A1%2C+acabei+de+preencher+meus+dados+no+site+de+voc%C3%AAs+e+gostaria+de+mais+informa%C3%A7%C3%B5es%21&type=phone_number&app_absent=0`;

  // O `page_view` desta rota é emitido pelo AnalyticsTracker, no router.
  useEffect(() => {
    pushThankYouPageView();
  }, []);

  return (
    <Wrapper>
      <HeaderSuccess />
      <Page>
        <img
          src={womanCallCenter}
          alt="Mulher atendendo no call center"
          height={350}
        />
        <Title>
          Cadastro recebido
          <CheckBadge>
            <FontAwesomeIcon icon={faCheck} />
          </CheckBadge>
        </Title>
        <Subtitle>
          Em breve um de nossos colaboradores entrarão em contato! Obrigado.
        </Subtitle>
        <Hint>
          Clique no botão abaixo se preferir ser atendido mais rápido.
        </Hint>
        <WhatsAppButton
          href={whatsappHref}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => pushWppThankYouClick()}
        >
          Falar com um atendente agora!
        </WhatsAppButton>
      </Page>
      <FooterSuccess />
    </Wrapper>
  );
}
